import {
    NormalizedBuildEvents,
    NormalizedDeviceEvents,
    NormalizedEventReport,
    NormalizedFileEvents,
    NormalizedGroupEvents,
    NormalizedLicenseEvents,
    NormalizedProductEvents,
    NormalizedProvisioningEvents,
    NormalizedSubscriptionEvents,
} from "src/services/eventVersionService/eventVersionService.types";

import { MdmCommand } from "./commands";

export type MdmPolicyCommand = API.Policy;

export type DeviceId = number;
export type DeviceWarning = "lowMemory" | "lowBattery" | "nonCompliant";
export type DeviceState = API.DeviceState;
export type Device = API.Device & { commands?: MdmCommand[]; lastState: DeviceState | null };
export type DeviceSetting = API.DeviceSetting;
export type License = Omit<API.License, "device"> & { device: Device | null; queryMap: Record<string, string> };
export type Group = Omit<API.Group, "members"> & { commands?: MdmCommand[]; members: GroupMember[] };
export type GroupMember = API.Member;
export type GroupRoles = GroupMember["role"];

export type Profile = API.Profile;
export type ProfileBillingAddress = API.BillingAddress;

export type Subscription = API.Subscription;

export enum PolicyStatus {
    COMPLIANT = "COMPLIANT",
    NON_COMPLIANT = "NON_COMPLIANT",
    NO_GROUP_POLICY = "NO_GROUP_POLICY",
}

export type BuildEvents = NormalizedBuildEvents;
export type DeviceEvents = NormalizedDeviceEvents;
export type FileEvents = NormalizedFileEvents;
export type GroupEvents = NormalizedGroupEvents;
export type ProductEvents = NormalizedProductEvents;
export type ProvisioningEvents = NormalizedProvisioningEvents;
export type SubscriptionEvents = NormalizedSubscriptionEvents;
export type LicenseEvents = NormalizedLicenseEvents;
export type EventReport = NormalizedEventReport;
export type BwcConfig = API.JkcCameraConfig;
